import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import {
  LEAD_CATEGORY,
  SUPPLY_NAME,
  RWA_TENURE,
  SUPPLY_DROP_DOWN,
  CORPORATE_DROP_DOWN,
  B2B_DROP_DOWN,
} from "./type";

export const leadCategories = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    Config.categoryDetials.lead
  );
  const payload = res?.data?.data ?? res?.data?.response?.data;
  if (payload) {
    dispatch({ type: LEAD_CATEGORY, payload });
    return true;
  }
};

export const supplyNameFun = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    Config.categoryDetials.supplyName
  );
  const payload = res?.data;
  const ok =
    Number(payload?.status) === 0 ||
    payload?.response?.status === true ||
    payload?.status === true;
  if (res && ok) {
    const { data } = res;
    dispatch({
      type: SUPPLY_NAME,
      payload: data.response?.data ?? data.data,
    });
    return true;
  }
  return false;
};

export const rwaTenureFun = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    Config.categoryDetials.rwaTenure
  );
  if (res?.data?.status === true || res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({ type: RWA_TENURE, payload: data.response.data });
    return true;
  }
};

export const getSupplyDropDown = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    Config.categoryDetials.supplyDropDown
  );
  if (res?.data?.status === true || res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({ type: SUPPLY_DROP_DOWN, payload: data.response.data });
    return true;
  }
};

export const getCorporateDropDown = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    Config.categoryDetials.corporateDropDown
  );
  if (res?.data?.status === true || res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({ type: CORPORATE_DROP_DOWN, payload: data.response.data });
    return true;
  }
};

export const getB2bDropDown = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    Config.createLead.b2bDropdown
  );
  if (res?.data?.status === true || res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({ type: B2B_DROP_DOWN, payload: data.response.data });
    return true;
  }
};
